import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Save } from 'lucide-react';
interface EditProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: any;
  onSave: (data: any) => void;
}
export function EditProductModal({
  isOpen,
  onClose,
  product,
  onSave
}: EditProductModalProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-165">
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-166">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" data-id="element-167" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden" data-id="element-168">
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100" data-id="element-169">
            <h2 className="text-lg font-bold text-navy-900" data-id="element-170">Editar Produto</h2>
            <button onClick={onClose} className="text-slate-400 hover:text-navy-900 transition-colors" data-id="element-171">
              <X className="h-5 w-5" data-id="element-172" />
            </button>
          </div>

          <div className="p-6 space-y-4" data-id="element-173">
            <div className="grid grid-cols-2 gap-4" data-id="element-174">
              <div className="space-y-1" data-id="element-175">
                <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-176">
                  SKU
                </label>
                <input type="text" defaultValue={product?.sku} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm font-mono focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-177" />
              </div>
              <div className="space-y-1" data-id="element-178">
                <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-179">
                  Categoria
                </label>
                <select defaultValue={product?.category} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900 bg-white" data-id="element-180">
                  <option data-id="element-181">Eletrônicos</option>
                  <option data-id="element-182">Eletrodomésticos</option>
                  <option data-id="element-183">Informática</option>
                  <option data-id="element-184">Games</option>
                </select>
              </div>
            </div>

            <div className="space-y-1" data-id="element-185">
              <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-186">
                Nome do Produto
              </label>
              <input type="text" defaultValue={product?.name} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-187" />
            </div>

            <div className="space-y-1" data-id="element-188">
              <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-189">
                Fornecedor
              </label>
              <input type="text" defaultValue={product?.supplier} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-190" />
            </div>

            <div className="grid grid-cols-2 gap-4 pt-2" data-id="element-191">
              <div className="space-y-1" data-id="element-192">
                <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-193">
                  Preço Atual (R$)
                </label>
                <input type="number" defaultValue={product?.price} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm font-bold text-navy-900 focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-194" />
              </div>
              <div className="space-y-1" data-id="element-195">
                <label className="text-xs font-medium text-slate-500 uppercase" data-id="element-196">
                  Preço Mínimo (R$)
                </label>
                <input type="number" defaultValue={product?.minPrice || product?.price * 0.8} className="w-full px-3 py-2 border border-red-200 bg-red-50 rounded-lg text-sm font-medium text-red-900 focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-197" />
              </div>
            </div>
          </div>

          <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3" data-id="element-198">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-navy-900 transition-colors" data-id="element-199">
              Cancelar
            </button>
            <button onClick={() => {
            onSave({});
            onClose();
          }} className="px-4 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium hover:bg-navy-800 transition-colors flex items-center shadow-sm" data-id="element-200">
              <Save className="h-4 w-4 mr-2" data-id="element-201" />
              Salvar Alterações
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}